import { z } from 'zod';

export enum Platform {
  MS_TEAMS = "ms-teams",
  UPLOAD = "upload"
}

export const PlatformEnum = z.nativeEnum(Platform);
export type PlatformEnum = z.infer<typeof PlatformEnum>
